export default __webpack_public_path__ + "static/media/mallory_mp_compact_black_italic.0b3ecde4.ttf";